var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.getTitle))]),(_vm.showDownload)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.download()}}},[_c('v-icon',[_vm._v(" mdi-file ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }